var map = {
	"./sensorencoders/BREEZE-v1.1Downlink": 658,
	"./sensorencoders/BREEZE-v1.1Downlink.js": 658,
	"./sensorencoders/CHICKADEE-v2.3Downlink": 7865,
	"./sensorencoders/CHICKADEE-v2.3Downlink.js": 7865,
	"./sensorencoders/COMFORT-VIVID-v2.2Downlink": 6149,
	"./sensorencoders/COMFORT-VIVID-v2.2Downlink.js": 6149,
	"./sensorencoders/COMFORT-VIVID-v3.1Downlink": 6881,
	"./sensorencoders/COMFORT-VIVID-v3.1Downlink.js": 6881,
	"./sensorencoders/COMFORT-VIVID-v4.0Downlink": 5301,
	"./sensorencoders/COMFORT-VIVID-v4.0Downlink.js": 5301,
	"./sensorencoders/COMFORT-VIVID-v4.2Downlink": 3805,
	"./sensorencoders/COMFORT-VIVID-v4.2Downlink.js": 3805,
	"./sensorencoders/COMFORT-VIVID-v4.3Downlink": 5837,
	"./sensorencoders/COMFORT-VIVID-v4.3Downlink.js": 5837,
	"./sensorencoders/Industrial-Transceiver-1wire-v1.11Downlink": 5147,
	"./sensorencoders/Industrial-Transceiver-1wire-v1.11Downlink.js": 5147,
	"./sensorencoders/Industrial-Transceiver-v2.1Downlink": 3108,
	"./sensorencoders/Industrial-Transceiver-v2.1Downlink.js": 3108,
	"./sensorencoders/KIWI-ALL-PORT-10-v2.0Downlink": 3475,
	"./sensorencoders/KIWI-ALL-PORT-10-v2.0Downlink.js": 3475,
	"./sensorencoders/KIWI-CLOVER-v2.0Downlink": 126,
	"./sensorencoders/KIWI-CLOVER-v2.0Downlink.js": 126,
	"./sensorencoders/KIWI-v2.0Downlink": 365,
	"./sensorencoders/KIWI-v2.0Downlink.js": 365,
	"./sensorencoders/MEMO-(demo)Downlink": 8574,
	"./sensorencoders/MEMO-(demo)Downlink.js": 8574,
	"./sensorencoders/ORCA-v0.14Downlink": 4198,
	"./sensorencoders/ORCA-v0.14Downlink.js": 4198,
	"./sensorencoders/ORCA-v1.0Downlink": 5999,
	"./sensorencoders/ORCA-v1.0Downlink.js": 5999,
	"./sensorencoders/SEAL-v1Downlink": 1189,
	"./sensorencoders/SEAL-v1Downlink.js": 1189,
	"./sensorencoders/SPARROW-PELICAN-v2.8Downlink": 4856,
	"./sensorencoders/SPARROW-PELICAN-v2.8Downlink.js": 4856,
	"./sensorencoders/SPARROW-PELICAN-v3.1Downlink": 7700,
	"./sensorencoders/SPARROW-PELICAN-v3.1Downlink.js": 7700,
	"./sensorencoders/STORK-v2.0Downlink": 9902,
	"./sensorencoders/STORK-v2.0Downlink.js": 9902,
	"./sensorencoders/STORK-v2.1Downlink": 9095,
	"./sensorencoders/STORK-v2.1Downlink.js": 9095,
	"./sensorencoders/STORK-v2.2Downlink": 1610,
	"./sensorencoders/STORK-v2.2Downlink.js": 1610,
	"./sensorencoders/TUNDRA-v2.1Downlink": 2562,
	"./sensorencoders/TUNDRA-v2.1Downlink.js": 2562,
	"./sensorencoders/eBeat-v1.0Downlink": 8578,
	"./sensorencoders/eBeat-v1.0Downlink.js": 8578,
	"./sensorencoders/eBeat-v1.xDownlink": 7671,
	"./sensorencoders/eBeat-v1.xDownlink.js": 7671,
	"./sensorencoders/eDoctor-v0.15Downlink": 3063,
	"./sensorencoders/eDoctor-v0.15Downlink.js": 3063,
	"./sensorencoders/eDoctor-v1.2Downlink": 5903,
	"./sensorencoders/eDoctor-v1.2Downlink.js": 5903,
	"./sensorencoders/eDoctor-v1Downlink": 7964,
	"./sensorencoders/eDoctor-v1Downlink.js": 7964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8950;